import { useState } from 'react';
import { Alert, Button, Group, Text } from '@mantine/core';
import { IconMail, IconCheck } from '@tabler/icons-react';
import { useAuth } from '@/hooks/useAuth';

export function EmailVerificationBanner() {
  const { user, isEmailVerified, resendVerificationEmail } = useAuth();
  const [isResending, setIsResending] = useState(false);
  const [resendSuccess, setResendSuccess] = useState(false);

  // Don't show if no user or already verified
  if (!user || isEmailVerified) {
    return null;
  }

  const handleResend = async () => {
    setIsResending(true);
    const result = await resendVerificationEmail();
    setIsResending(false);
    if (result.success) {
      setResendSuccess(true);
      setTimeout(() => setResendSuccess(false), 5000);
    }
  };

  return (
    <Alert
      icon={resendSuccess ? <IconCheck size={18} /> : <IconMail size={18} />}
      color={resendSuccess ? 'green' : 'yellow'}
      variant="light"
      style={{ borderRadius: 0 }}
    >
      <Group justify="space-between" wrap="nowrap" gap="xs">
        <Text size="sm">
          {resendSuccess
            ? 'Verification email sent! Check your inbox.'
            : `Please verify your email address (${user.email}) to ensure full access.`}
        </Text>
        {!resendSuccess && (
          <Button
            size="xs"
            variant="light"
            color="yellow"
            onClick={handleResend}
            loading={isResending}
          >
            Resend
          </Button>
        )}
      </Group>
    </Alert>
  );
}
